module.exports = __webpack_public_path__ + "img/portrait.a5af948e.jpg";